import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IUserProfileComplete, Profile } from '../shared/interfaces/profile.interface';
import { Observable, map, of, switchMap } from 'rxjs';
import { ContentService } from './content.service';
import { environment } from 'src/environments/environment.development';
const HOST = environment.host;
// const API_URL = environment.apiUrl;
@Injectable({
  providedIn: 'root',
})
export class UserProfileService {
  BASE_URL = 'https://backoffice.aprendity.com';
  constructor(
    private http: HttpClient,
    private getContentService: ContentService
  ) {}

  updateProfile(form:any, id:string, csrf:any):Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
        'X-Csrf-Token': csrf || null,
        'Allow-Origin-With-Credentials': 'true',
      }),
      withCredentials: true,
    };
    return this.http.patch<any>(`${HOST}/api/user/user/${id}`, form, httpOptions);
  }

  // getUserProfileComplete(id: any) {
  //   console.log('id:', id);
  //   return this.http
  //     .get<Profile>(`${this.BASE_URL}/api/user/user/${id}`)
  //     .pipe(map(({data}:any) =>  {
  //       this.getContentService.getFileContent(data.relationships.user_picture.data.id).subscribe(resp => {
  //         return of({
  //           field_birthdate: data.attributes.field_birthdate,
  //           field_city: data.attributes.field_city,
  //           field_country: data.attributes.field_country,
  //           field_document: data.attributes.field_document,
  //           field_lastname: data.attributes.field_lastname,
  //           field_name: data.attributes.field_name,
  //           field_profession: data.attributes.field_profession,
  //           field_profile: data.attributes.field_profile,
  //           mail: data.attributes.mail,
  //           name: data.attributes.name,
  //           status: data.attributes.status,
  //           user_picture: resp,
  //         })
  //       })

  //     }

  //     ));
  // }

  getUserProfileCompleteById(id: any):Observable<IUserProfileComplete> {
    return this.http.get<Profile>(`${this.BASE_URL}/api/user/user/${id}`).pipe(
      switchMap(({ data }: any) => {
        if(!data.relationships.user_picture?.data?.id) {
          // console.log('no  image profile',data.attributes.display_name);
          console.log(data.attributes)
          return of({
            field_birthdate:  null,
            display_name: data.attributes.display_name || null,
            field_city:null,
            field_display_name:data.attributes.display_name || null,
            field_country:null,
            field_document:null,
            field_lastname: data.attributes.field_lastname || null,
            field_name: data.attributes.field_name || null,
            field_profession: null,
            field_profile:null,
            mail: data.attributes.mail || null,
            name: null,
            status: null,
            user_picture: {url:null},
          })
        }
        return this.getContentService
          // .getFileContent(data.relationships.user_picture.data?.id)
          .getFileContent(data.relationships.user_picture?.data?.id || 'null')
          .pipe(
            map((dataContentPicture: any) =>
             {
              return ({
                field_birthdate: data.attributes.field_birthdate || null,
                field_city: data.attributes.field_city || null,
                display_name: data.attributes.display_name || null,
                field_country: data.attributes.field_country || null,
                field_document: data.attributes.field_document || null,
                field_lastname: data.attributes.field_lastname || null,
                field_display_name: data.attributes.display_name || null,
                field_name: data.attributes.field_name || null,
                field_profession: data.attributes.field_profession || null,
                field_profile: data.attributes.field_profile || null,
                mail: data.attributes.mail || null,
                name: data.attributes.name || null,
                status: data.attributes.status || null,
                user_picture: dataContentPicture || null,
              })
             }
            )
          );
      })
    );
  }
}
